import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  MaintenancePlanForm,
  MaintenancePlanFormValues,
} from "../../components/maintenance-plan-form";
import { Modal } from "../../components/modal";
import { createMaintenancePlan } from "../../services/maintenance-plan";
import { navigateBack } from "../../utils/navigate-back";

export function MaintenancePlanCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [formValues, setFormValues] = useState<MaintenancePlanFormValues>({
    maintenancePlanCode: "",
    propertyPart: "",
    description: "",
    cost: "",
    yearlyFrequency: "",
  });

  const closeModal = () => {
    navigateBack(navigate, "/admin/maintenance/plan");
  };

  return (
    <Modal open onClose={closeModal}>
      <MaintenancePlanForm
        hasError={hasError}
        loading={loading}
        values={formValues}
        onCancel={closeModal}
        onChange={setFormValues}
        onSubmit={() => {
          void (async () => {
            setLoading(true);
            setHasError(false);
            try {
              await createMaintenancePlan({
                maintenancePlanCode: formValues.maintenancePlanCode,
                propertyPart: formValues.propertyPart,
                description: formValues.description,
                ...(formValues.cost !== "" && {
                  cost: Number(formValues.cost),
                }),
                ...(formValues.yearlyFrequency !== "" && {
                  yearlyFrequency: Number(formValues.yearlyFrequency),
                }),
              });
              await queryClient.invalidateQueries({
                queryKey: ["maintenancePlans"],
              });
              closeModal();
            } catch {
              setHasError(true);
            } finally {
              setLoading(false);
            }
          })();
        }}
      />
    </Modal>
  );
}
